export default "__VITE_ASSET__BiudPDqC__"